<template>
  <div class="questionBox">
    <ul>
      <li
        v-for="(item, index) in questionList"
        :key="index"
        :class="questionIndex == index ? 'active' : ''"
        @click="show(index)"
      >
        <div class="questionDetail">
          <h5 class="name">{{item.name}}</h5>
          <p class="desc">{{item.describe}}</p>
        </div>
        <div :class="['questionDetailList',questionIndex == index ? 'showList' : '']">
          <ul>
            <li
              v-for="(item1, index1) in item.list"
              :key="index + index1"
              @click.stop="goDetail(item1)"
            >
              <p>{{item1.title}}</p>
              <i></i>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "常见问题",
    };
  },
  name: "question",
  data() {
    return {
      questionIndex: -1,
      questionList: [
        {
          helptype: 2000,
          name: "账号问题",
          describe: "账号绑定/账号注销等",
          list: [],
        },
        {
          helptype: 2001,
          name: "服务问题",
          describe: "作品点评/视频连线/1V1面授/线下课程等",
          list: [],
        },
        {
          helptype: 2002,
          name: "提现问题",
          describe: "银行卡绑定/佣金抽成/到账时间等",
          list: [],
        },
        {
          helptype: 2003,
          name: "其他问题",
          describe: "报错、异常等",
          list: [],
        },
      ],
    };
  },

  mounted() {
    this.getQuestion();
  },
  methods: {
    show(index) {
      this.questionIndex = this.questionIndex == index ? -1 : index;
    },
    getQuestion() {
      var questionList = this.questionList;
      for (let i = 0; i < questionList.length; i++) {
        var obj = {
          helptype: questionList[i].helptype,
        };
        this.$post(
          "/gart-common-api/api/cmn/platform/queryByPlatformHelps",
          obj
        ).then((res) => {
          if (res.code == 1) {
            this.questionList[i].list = res.data;
          } else {
            this.util.toast({ msg: res.message });
          }
        });
      }
    },
    goDetail(item) {
      this.$store.commit("setQuestion", JSON.stringify(item));
      this.$router.push({
        path: "/teacher/common/question/questionDetail",
        query: {},
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.questionBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #ffffff;
  padding: 16px;
  > ul {
    > li {
      border: 0.5px solid #ededed;
      border-radius: 8px;
      margin-bottom: 16px;
      .questionDetail {
        padding: 16px 0 ;
        margin: 0 16px;
        padding-right: 20px;
        position: relative;
        h5 {
          font-size: 16px;
          font-weight: bold;
          line-height: 22px;
          color: #35363c;
          padding-bottom: 8px;
        }
        p {
          font-size: 12px;
          font-weight: 300;
          line-height: 17px;
          color: #35363c;
        }
      }
      .questionDetailList {
        background: #ffffff;
        height: 0;
        overflow: hidden;
        transition: all linear 0.2s;
        > li {
          display: flex;
          flex-direction: row;
          align-items: center;
        }
      }
      .showList {
        height: auto;
        overflow: hidden;
        transition: all linear 0.2s;
        background: #f4f4f7;
         border-radius: 0 0 8px 8px;
        > ul {
          > li {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            p {
              padding: 15px 24px 16px;
              flex: 1;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 12px;
              font-weight: 300;
              line-height: 17px;
              color: #35363c;
            }
            i {
              display: inline-block;
              width: 16px;
              height: 16px;
              background: url(../../../../assets/img/teacher/arrow_bottom.png)
                no-repeat;
              transform: rotate(-90deg);
              background-size: 16px 16px;
               margin-right: 16px;
            }
          }
          > li:not(:last-child) {
            border-bottom: 1px solid #EDEDED;
          }
        }
      }
      .questionDetail::before {
        content: " ";
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url(../../../../assets/img/teacher/arrow_bottom.png)
          no-repeat;
        background-size: 16px 16px;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -5.5px;
        transform: rotate(0);
        transition: all linear 0.2s;
      }
    }
    > li.active .questionDetail {
      border-bottom-color: transparent;
      padding-bottom: 12px;
    }
    > li.active .questionDetail::before {
      transform: rotate(-180deg);
      transition: all linear 0.2s;
    }
  }
}
</style>
